// DTM
import React, { Component } from "react";
import styled from "styled-components";

import ArticleAbstract from "./ArticleAbstract";
import ArticleBlueBox from "./ArticleBlueBox";

const Inner = styled.div`
  width: 50%;
  float: left;

  display: flex;
  flex-direction: column;
  @media (max-width: 700px) {
    width: 100%;
    :first-child {
      margin-top: 15px;
    }
  }
`;

class SetCountingBlueBox extends Component {
  render() {
    let first = this.props.set[0];
    let itemsLeft = [];
    let itemsRight = [];
    let left = Math.ceil((this.props.set.length - 1) / 2);
    for (let i in this.props.set) {
      if (i > 0) {
        if (i > left) {
          itemsRight.push(this.props.set[i]);
        } else {
          itemsLeft.push(this.props.set[i]);
        }
      }
    }
    return (
      <ArticleBlueBox thin content={first}>
        <Inner>
          {itemsLeft.map((item, index) => (
            <Countable key={item.id} content={item} no={index + 1} />
          ))}
        </Inner>
        <Inner>
          {itemsRight.map((item, index) => (
            <Countable key={item.id} content={item} no={index + 1 + left} />
          ))}
        </Inner>
      </ArticleBlueBox>
    );
  }
}

export default SetCountingBlueBox;

const Item = styled.div`
  width: calc(100% - 78px);
  padding: 10px 18px 10px 60px;
  text-align: left;
  position: relative;
  height: 5.5em;
  display: flex;
  align-items: center;
  justify-content: center;
  @media (max-width: 700px) {
    width: calc(100% - 58px);
    padding: 5px 8px 5px 50px;
  }
`;
const Text = styled.div`
  width: 100%;
  overflow: hidden;
`;
const Digit = styled.div`
  position: absolute;
  top: calc(50% - 20px);
  line-height: 40px;
  left: 0px;
  width: 60px;
  font-size: 40px;
  text-align: center;
  @media (max-width: 700px) {
    left: 0px;
    width: 40px;
    font-size: 35px;
  }
`;

class Countable extends ArticleAbstract {
  render() {
    return (
      <Item {...this.link()}>
        <Text>{this.title()}</Text>
        <Digit>{this.props.no}</Digit>
      </Item>
    );
  }
}



// WEBPACK FOOTER //
// ./src/components/SetCountingBlueBox.js